// extracted by mini-css-extract-plugin
export default {"tooltip":"pS-z","arrow":"qS-z"};